import React from 'react';

const ServiceWorkerState = React.createContext({outOfDate: false, msg: ''});

export default ServiceWorkerState;